import React from 'react'
import { useRouterState } from '@tanstack/react-router'
import { LoginDialog } from '../LoginDialog'
import { SignupDialog } from '../SignupDialog'
import { Footer } from '../footer'
import { PersonalInfoDialog } from '../PersonalInfoDialog'
import { SideBarLayout } from '../SideBar/SideBarLayout'
import { SidebarProvider } from '@duck/ui'


interface GeneralLayoutComponentProps {
  children: React.ReactNode;
}

const widePages = ['/challenge/']

const MainContentWrapper = ({ fullWidth = false, children }: { fullWidth?: boolean, children: React.ReactNode }) => {
  if (fullWidth) {
    return (
      <div className="flex flex-col min-h-[560px] flex-1">
        {children}
      </div>
    )
  }
  return (
    <main
      className={`flex-1 flex justify-center px-4 md:px-6 lg:px-8 w-full min-h-screen md:max-w-[calc(100dvw-var(--sidebar-current-width))]`}
    >
      <div className={`flex w-full justify-center mb-16 max-w-6xl pt-8`}>
        {children}
      </div>
    </main>
  )
}

export const GeneralLayoutComponent: React.FC<GeneralLayoutComponentProps> = ({
  children,
}) => {
  const routerState = useRouterState()

  const shouldBeWide = widePages.some((route) =>
    routerState.location.pathname.startsWith(route)
  )
  return (
    <SidebarProvider defaultOpen={true}>
      <SideBarLayout>
        <div className={`flex flex-col flex-1`}>
          <MainContentWrapper fullWidth={shouldBeWide}>
            {children}
          </MainContentWrapper>
        </div>

        {!shouldBeWide && <Footer />}

        <LoginDialog />
        <SignupDialog />
        <PersonalInfoDialog />
      </SideBarLayout>
    </SidebarProvider>
  )
}
